import Component from './twitter_instantwin_add_edit.vue'
export default Component
